<template>
    <ais-refinement-list attribute="authors.slug" :transform-items="transformItems" :sort-by="sortBy">
        <template slot-scope="{ items, refine}">
            <div v-for="item in items" :key="item.value">
                <button
                    @click.prevent="refine(item.value)"
                    class="flex font-light items-center text-base outline-none mb-2 focus:outline-blue"
                >
                    <span
                        class="block rounded-full w-8 h-8 mr-2 shadow border-2 border-white relative overflow-hidden"
                        :style='{backgroundColor: item.color }'
                        :class="{
                        'border-blue-700':item.isRefined,
                        'border-white' : !item.isRefined}"
                    >
                        <img
                            v-if="item.imageUrl" :src="item.imageUrl"
                            class="inset-0 absolute" :alt="item.name"
                        />
                        <span v-else class="absolute flex items-center justify-center inset-0 text-white">
                            <span class="font-normal">{{ item.name.substring(0, 1) }}</span>
                        </span>
                        <span
                            class="bg-yellow-400 absolute z-20 absolute flex items-center justify-center inset-0 text-blue-700"
                            v-if="item.isRefined"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                class="w-4 h-4"
                            >
                              <path
                                  fill-rule="evenodd"
                                  d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z"
                                  clip-rule="evenodd"
                              />
                            </svg>
                        </span>
                    </span>
                    <span>{{ item.name }}</span>
                </button>
            </div>
        </template>
    </ais-refinement-list>
</template>

<script>


export default {
    name: "EmployeeRefinement",
    props: {
        employees: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            sortBy: ['name:asc']
        };
    },
    methods: {
        transformItems(items) {
            return items.map(item => {
                const employee = this.employees.find(employee => employee.slug === item.value);

                return {
                    ...item,
                    color: employee.color,
                    name: employee.name,
                    imageUrl: employee.image_url
                };
            });
        }
    },
};
</script>

<style scoped>

</style>
